import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useTokenStore from '../../stores/tokens';
import { compatApi } from '../../utils/Intercepter';
import { PURPLE, MINT } from '../../utils/designUtils';

export default function MyInfoChangePw() {
    useTokenStore();
    const navigate = useNavigate();

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirm, setNewPasswordConfirm] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        const credentials = { currentPassword, newPassword, newPasswordConfirm };

        try {
            const response = await compatApi.post("/my-info/change-pw", credentials);
            const data = response.data;
            console.log(data);
            if (!data.result) {
                alert(data.message);
                return;
            }
            alert(data.message);
            navigate('/my-info/details');
        } catch (error) {
            console.log(error.response.data.message);
            if (error.response) {
                const status = error.response.status;
                if (status === 400) {
                    alert('잘못된 요청입니다.');
                } else {
                    alert(error.response.data.message);
                }
            } else {
                alert('네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            }
        }
    };

    const isSubmittable = currentPassword && newPassword && newPasswordConfirm;
    const label = { display: 'block', fontWeight: 600, marginBottom: 6, color: '#1f1d2e', fontSize: 14 };
    const inputStyle = {
        width: '100%', padding: '12px 14px', borderRadius: 10,
        border: '1.5px solid #e5e0f7', outline: 'none', fontSize: 14,
        color: '#1f1d2e', background: '#faf9fe', boxSizing: 'border-box', boxShadow: 'none'
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 61px)', background: '#f5f4fa' }}>
            <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(124,107,217,0.10)', border: '1px solid rgba(124,107,217,0.12)', padding: '40px', width: '100%', maxWidth: 440 }}>
                <h2 style={{ textAlign: 'center', fontWeight: 700, marginBottom: 28, color: '#1f1d2e', fontSize: 20 }}>
                    비밀번호 변경
                </h2>
                <form onSubmit={handleSubmit} style={{ maxWidth: 'none', margin: 0, padding: 0, border: 'none', borderRadius: 0, background: 'none' }}>
                    <div style={{ marginBottom: 16 }}>
                        <label style={label}>현재 비밀번호</label>
                        <input
                            name="currentPassword"
                            type="password"
                            placeholder="비밀번호"
                            autoComplete="off"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            style={inputStyle}
                        />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <label style={label}>새 비밀번호</label>
                        <input
                            name="newPassword"
                            type="password"
                            placeholder="비밀번호"
                            autoComplete="off"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            style={inputStyle}
                        />
                    </div>
                    <div style={{ marginBottom: 24 }}>
                        <label style={label}>새 비밀번호 확인</label>
                        <input
                            name="newPasswordConfirm"
                            type="password"
                            placeholder="비밀번호"
                            autoComplete="off"
                            value={newPasswordConfirm}
                            onChange={(e) => setNewPasswordConfirm(e.target.value)}
                            style={inputStyle}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={!isSubmittable}
                        style={{
                            display: 'block', width: '100%', padding: '13px', borderRadius: 10,
                            background: isSubmittable ? `linear-gradient(135deg, ${PURPLE}, ${MINT})` : '#e5e0f7',
                            color: isSubmittable ? '#fff' : '#a0a0b0',
                            fontWeight: 700, fontSize: 15, border: 'none',
                            cursor: isSubmittable ? 'pointer' : 'not-allowed'
                        }}
                    >
                        비밀번호 변경
                    </button>
                </form>
            </div>
        </div>
    );
}
